<script>
import SizeNotMatchingIcon from "../elements/sizeNotMatchingIcon.vue";
import elementIcon from "../elements/element-icon.vue";
import VTooltipWrapper from "../../common/v-tooltip-wrapper.vue";
import TextEllipsisWithTooltip from "../common/TextEllipsisWithTooltip.vue";
import Template from "../elements/template.vue";
import WarningIcon from "../elements/warningIcon.vue";

export default {
    name: "publish-element-title",
    components: {WarningIcon, Template, TextEllipsisWithTooltip, VTooltipWrapper, elementIcon, SizeNotMatchingIcon},
    props: {
        name: String,
        readonly: Boolean,
        sizeNotMatching: Boolean,
        propsNotSet: Boolean,
        data: Object,
        layer: Object,
    },
    computed: {
        translations() {
            return {
                readonly: Lang.langGet('READ ONLY'),
                screenNotAllowed: Lang.langGet('You are not allowed to modify this element, because screens / screengroups are missing. You have to get them assigned via usergroups.'),
                propsNotSet: Lang.langGet('Required properties have not been set.'),
            }
        },
        containerClass() {
            return {
                'publish-element-readonly': this.readonly,
                'publish-element-sizenotmatching': this.sizeNotMatching || this.propsNotSet,
                'publish-element-linked': this.data.state == 'link',
                'publish-element-copied': this.data.state == 'copy',
            };
        }
    }
}
</script>

<template>
    <div :class="containerClass" class="publish-element-title-background">
        <elementIcon :container-classes="['element-icon-container-gap']" :data="data">
            <size-not-matching-icon :layer="layer" :data="data" v-if="sizeNotMatching"/>
            <warning-icon v-if="propsNotSet" :text="translations.propsNotSet"/>
            <v-tooltip-wrapper v-if="readonly"
                :max-width="380"
                :nudge-bottom="2"
                :open-delay="350"
                content-class="tooltip-glass tooltip-white elevation-8 tooltip-border-colored tooltip-border-readonly"
            >
                <template #activator="{ on, attrs }">
                    <i class="far fa-lock-keyhole color-readonly-icon" v-bind="attrs" v-on="on"/>
                </template>
                <span><b>{{ translations.readonly }}</b></span>
                <br/>
                <span>{{ translations.screenNotAllowed }}</span>
            </v-tooltip-wrapper>
        </elementIcon>

        <text-ellipsis-with-tooltip v-if="name" :text="name"/>
    </div>
</template>
